// extracted by mini-css-extract-plugin
module.exports = {"button":"da51a739f7--button--zOxpp"};